import './pexel.css'
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import { useEffect, useState } from 'react';







const Pexelsc = () => {

  const[quesry ,setquery] = useState('ghost');
  const[quesry2 ,setquery2] = useState('ghost');

  const [itemData, setitemdata] = useState([])
 
  
  const queryselector2 = () =>{
    console.log(quesry2)
    setquery(quesry2)
  }


  const queryselector = (e) =>{
    setquery2(e.target.value);
    console.log(quesry2)
  }

 

 

  const fetchdataimg = async () => {
    const url = `https://pexelsdimasv1.p.rapidapi.com/v1/search?query=${quesry}&per_page=90000`



    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: 'ux20I2WMvMkpXriDH1zO1tkhNeIUv1o77uevj6DT76JAEbtzOCJeeUcF',
        'X-RapidAPI-Key': '041c592888msh8368f8d6b6be833p1e8b12jsn793815d28b47',
        'X-RapidAPI-Host': 'PexelsdimasV1.p.rapidapi.com'
      }
    });
    const resjs = await response.json();
    setitemdata(resjs.photos)
  
  

  }
  useEffect( () => {
    fetchdataimg();

  },[quesry])
  return (
    <div>
        { itemData.length !==0 ? <div>
          <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container-fluid  ">
    
    
              <a class="navbar-brand" href="#">Navbar</a>
    
    
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
              </button>
    
    
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
            
              <div class="d-flex komal" role="search">
                <input class="form-control me-2" onChange={queryselector} type="search" placeholder="Search" aria-label="Search" />
                <button class="btn btn-outline-success" onClick={queryselector2} type="submit">Search</button>
              </div>
            </div>
    
    
            </div>
          </nav>
    
    
          <div className="gridimg">
            {itemData.map((item) => (
              <div className="imageb">  <img src={item.src.large2x} alt="loading" /></div>
    
            ))}
    
    
    
          </div></div>
      : <div> ho</div> }
    </div>
  );


}


export default Pexelsc;